module.exports = "<div class=\"wrapper about\">\r\n  <img src=\"./assets/img/me.jpg\"/>\r\n  <div [innerHTML]=\"aboutme | keepHTML\"></div>\r\n</div>\r\n"